import { render } from "./order-list.vue?vue&type=template&id=39496ea4&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"

import "./order-list.vue?vue&type=style&index=0&id=39496ea4&scoped=true&lang=css"
import "./order-list.vue?vue&type=style&index=1&id=39496ea4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39496ea4"]])

export default __exports__